import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { exists, translate } from "application/functions";
import SelectFieldComboInput from "form/components/select-field-combo/select-field-combo-input";
import {
  split,
  filter,
  startsWith,
  isEmpty,
  map,
  contains,
  is,
  includes,
} from "ramda";

const SelectAppointment = (props) => {
  const {
    register,
    errors,
    isSubmitted,
    locale,
    size,
    setSelectValue,
    required,
    field,
    options,
    show,
    value,
  } = props;

  /* useEffect(() => {
    if(!exists(options) || (exists(options) && exists(value) && !includes((is(Array, value) && !isEmpty(value)) ? value[0].toString() : value, map(o => o.key, options)))) {
      setValue(null);
    }
  }, options); */

  const fieldRequired = translate("field.required", locale);

  const getAuxiliarInputs = (option) => {
    return (
      <div style={{ display: "none" }} key={`aux-${option.key}`}>
        <label>
          <input
            type="checkbox"
            name={field}
            ref={register({ required })}
            value={option.key}
          />
          <span>{option.key}</span>
        </label>
      </div>
    );
  };

  const getOption = (option) => {
    return { value: option.key, label: option.label };
  };

  const onChange = (value) => {
    setSelectValue(field, value);
  };

  const onChangeMulti = (value) => {
    setSelectValue(field, value);
  };

  const name = translate(`field.${field}`, locale);

  const selectOptions = () => map((option) => getOption(option), options);

  return (
    <Fragment>
      {map((option) => getAuxiliarInputs(option), options)}
      <SelectFieldComboInput
        name={required ? `*${name}` : name}
        isMulti={false}
        options={selectOptions()}
        onChange={(value) => onChange(value)}
        onChangeMulti={(value) => onChangeMulti(value)}
        size={size}
        locale={locale}
        show={show}
        value={value}
        field={field}
      />
      {errors[field] && isSubmitted && !isEmpty(selectOptions()) && (
        <div
          className="forms__error-message"
          style={{ marginTop: "-40px", marginBottom: "25px" }}
        >
          {fieldRequired}
        </div>
      )}
    </Fragment>
  );
};

SelectAppointment.propTypes = {
  register: PropTypes.any,
  errors: PropTypes.any,
  isSubmitted: PropTypes.bool,
  locale: PropTypes.string,
  size: PropTypes.string,
  setSelectValue: PropTypes.func,
  required: PropTypes.bool,
  field: PropTypes.string,
  options: PropTypes.array,
  show: PropTypes.bool,
  value: PropTypes.any,
};

export default SelectAppointment;
